/**
 * Utility to map dispatch to props for saved search actions.
 */
export const mapDispatchToSavedSearchActions = (
  dispatch,
  savedSearchActions
) => ({
  fetchSavedSearches: () => dispatch(savedSearchActions.fetchSavedSearches()),
  putSavedSearch: () => dispatch(savedSearchActions.putSavedSearch()),
  postSavedSearch: (name, type) =>
    dispatch(savedSearchActions.postSavedSearch(name, type)),
  deleteSavedSearch: id => dispatch(savedSearchActions.deleteSavedSearch(id)),
  setSelectedSavedSearch: (id, colDefs) =>
    dispatch(savedSearchActions.setSelectedSavedSearch(id, colDefs)),
  setSavedSearchDirty: isDirty =>
    dispatch(savedSearchActions.setSavedSearchDirty(isDirty)),
  setSavedSearchDirtyColumns: cols =>
    dispatch(savedSearchActions.setSavedSearchDirtyColumns(cols)),
})
